<div class="foru-selected-items" role="region" id="ariaChipsContainer" aria-label="Filters applied" >
<div id="info-label" [ngStyle]="{'display':selectedFilters.length === 0 ? 'none' : 'inline' }" aria-live="polite" aria-relevant="removals"></div>
  <div class="m-0 row">
      <button *ngFor="let filterChip of selectedFilters" class="foru-selected-chip d-inline-flex" id="{{filterChip.filterName}}_chips" attr.aria-label="{{filterChip.filterName}} filter, Click on this button to remove this filter" (click)="removeFilter(filterChip, $event)" (keypress.enter)="removeFilter(filterChip, $event)">
          {{ filterChip.filterName }}
          <div class="foru-selected-chip__close">
              <span class="foru-selected-chip__close__icon"></span>
          </div>
      </button>
  </div>
</div>